<template>
<div class="bg_img">
  <h1>You are not authorised to view this section please visit <a href="https://usmart.io/">www.usmart.io</a> to login.</h1>
</div>
</template>

<script>
export default { };
</script>

<style lang="scss" scoped>
  .bg_img {
    height: 100%;
    width: 100%;
    background-image: url('~@/assets/gradient_bg.png');
    place-content: center;
    align-items: center;
    display: flex;
    background-size:cover;
    color: #fff;
  }
    a:hover {
      color: paleturquoise;
    }
</style>
